<template>
  <div>
    <PullRefresh :refreshLoading="refreshLoading" @refresh="queryCourseNormalList">
      <van-list v-model="pullingUploading" :finished="finished" :error.sync="error" error-text="请求失败，点击重新加载" finished-text="没有更多了" @load="onPullingUp" :immediate-check="false">
        <van-cell-group>
          <van-cell v-for="course in courseList" :key="course.courseId" @click="viewCourse(course)">
            <template slot="title">
              <van-row>
                <van-col span="6" class="course-image">
                  <img :src="getImageUrl(course.courseImageUri)">
                </van-col>
                <van-col span="18" class="course-name">
                  {{ course.courseName }}
                </van-col>
              </van-row>
            </template>
          </van-cell>
        </van-cell-group>
      </van-list>
    </PullRefresh>
  </div>
</template>

<script>
import courseApi from '@/api/course'
import { commonUtils } from '@/utils/common'
import PullRefresh from '@/components/pull-refresh'
export default {
  name: 'CourseNormalList',
  props: {
    categoryId: {
      type: String,
      default: ''
    }
  },
  components: {
    PullRefresh
  },
  data () {
    return {
      courseList: [],
      queryParam: {
        curPage: 1,
        pageSize: 10
      },
      pageInfo: {
        totalPages: 1
      },
      refreshLoading: false,
      pullingUploading: false,
      finished: false,
      error: false
    }
  },
  created () {

  },
  methods: {
    getImageUrl: commonUtils.getImageUrl,
    load () {
      if (!this.categoryId) {
        return
      }
      this.queryCourseNormalList()
    },
    queryCourseNormalList (type) {
      // 下拉刷新
      if (type === 'pull-refresh') {
        this.refreshLoading = true
        this.queryParam = this.$options.data().queryParam
        this.finished = false
      }
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
        mask: true,
        message: '读取课程信息'
      })
      this.queryParam.categoryId = this.categoryId
      courseApi.queryCourseList(this.queryParam).then(response => {
        this.$toast.clear()
        if (response.data.resultCode === '0') {
          if (type === 'pull-up') {
            this.courseList = this.courseList.concat(response.data.resultData.courseList)
          } else {
            this.courseList = response.data.resultData.courseList
          }
          this.pageInfo = response.data.resultData.pageInfo
        }
        this.refreshLoading = false
        this.pullingUploading = false
      }).catch(() => {
        this.$toast.clear()
        this.refreshLoading = false
        this.pullingUploading = false
        this.error = true
      })
    },
    // 上拉加载
    onPullingUp () {
      console.log('pull up')
      console.log(this.queryParam.curPage)
      console.log(this.pageInfo.totalPages)
      if (this.queryParam.curPage < this.pageInfo.totalPages) {
        this.queryParam.curPage += 1
        this.queryCourseNormalList('pull-up')
      } else {
        this.finished = true
      }
    },
    viewCourse (course) {
      this.$dialog.alert({
        confirmButtonText: '确定',
        message: '课程内容请登录易加网站点下载<br><br>https://www.bosch-extra.com.cn'
      })
    }
  }
}
</script>

<style lang="less" scoped>
.course-image {
  text-align: center;

  img {
    max-width: 100%;
    max-height: 60px;
  }
}
.course-name {
  line-height: 60px;
}
</style>
